module.exports = __webpack_public_path__ + "img/logo.c8122861.png";